import { setupResourceStore } from '@/utils'
import Location from '@/resources/Location';

const resource = setupResourceStore(Location)


const state = {
  ...resource.state,
  selectedLocker: null
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};